import React from "react";

import { Square } from "@/features/common/components/square/Square";
import { PostPlaceholder } from "@/features/post/components/PostPlaceholder";

const ProfileMasonryPlaceholder = () => {
  return (
    <>
      {/* Mobile Placeholder */}
      <div
        className="md:hidden py-4"
        data-test-id="ProfileMasonryPlaceholder-mobilePlaceholderContainer"
      >
        <div className="h-40 mb-4 px-4">
          <div className="w-full h-full bg-gray-200" />
        </div>

        <div className="grid grid-cols-4 gap-px">
          {new Array(6).fill(0).map((_, idx) => {
            return (
              <Square key={idx}>
                <div className="relative h-full">
                  <span className="absolute w-full h-full bg-gray-200" />
                </div>
              </Square>
            );
          })}
        </div>
      </div>

      <div className="hidden md:block py-4">
        <PostPlaceholder />
      </div>
    </>
  );
};

export default ProfileMasonryPlaceholder;
